// import store from '@/store';

import store from '@/store';
import { onMounted, onBeforeUnmount } from "vue";
import Device from '.';
//import PowerStateWrapper from "@/helpers/Device/PowerStateWrapper";

console.log("#####################################TIZEN Device b2bapis (window):", window.hasB2bapis);
console.log("#####################################TIZEN Device webapis (window):", window.hasWebapis);

/*
const power = new PowerStateWrapper({
  onSuspend() {
    console.log("TV suspend → stop streams");
  },
  onResume() {
    console.log("TV resume → go home");
    router.replace({ name: "home" });
  },
  onVisible() {
    router.replace({ name: "home" });
  },
  onHidden() {
    console.log("TV hidden");
  },
});

onMounted(() => power.init());
onBeforeUnmount(() => power.destroy());
*/

// Wie lange reboot() auf den Callback wartet, bevor es trotzdem antwortet.
const REBOOT_REPLY_MS = 3000;

export default class Tizen {
  static get tvwindow() {
    if (!window.tizen) return undefined;
    return window.tizen.tvwindow;
  }

  static get b2bControl() {
    if (window.b2bapis) return window.b2bapis.b2bcontrol;
    if (window.webapis) return window.webapis.systemcontrol;
    return undefined;
  }

  static get b2bPower() {
    if (window.b2bapis) return window.b2bapis.b2bpower;
    if (window.webapis) return window.webapis.remotepower;
    return undefined;
  }

  static get getModel() {
    try {
      return webapis.productinfo.getRealModel();
    } catch (error) {
      console.log('ERROR - Tizen.getModel: ', error);
      return '';
    }
  }

  static get getVersion() {
    try {
      //return webapis.productinfo.getVersion();
      return window.tizen.systeminfo.getCapabilities().platformVersion;
    } catch (error) {
      console.log('ERROR - Tizen.getVersion: ', error);
      return '';
    }
  }

  static get getIP() {
     return webapis.network.getIp();
  }

  static get getMac() {
    try {
      return webapis.network.getMac();
    } catch (error) {
      console.log('ERROR - Tizen.getMac: ', error);
      return '00:00:00:00:00';
    }
  }
  static get getFirmware() {
    try {
      return webapis.productinfo.getFirmware();
    } catch (error) {
      console.log('ERROR - Tizen.getFirmware: ', error);
      return '';
    }
  }
  static get getPlatform() {
    try {
      return window.tizen.systeminfo.getCapability(
        'http://tizen.org/feature/platform.version'
      );
    } catch (error) {
      console.log('ERRROR: Tizen.getPlatform', error);
      return '';
    }
  }
  static get getSerial() {
    try {
      console.log("======================================================getSERIAL", this.b2bControl.getSerialNumber());
      return this.b2bControl.getSerialNumber();
    } catch (error) {
      console.log(' error code = ' + error.code);
      return '';
    }
  }
  static getResolutionHeight() {
    return screen.height;
  }
  static getResolutionWidth() {
    return screen.width;
  }

  static get getAppId() {
    try {
      return window.tizen.application.getCurrentApplication().appInfo.id;
    } catch (error) {
      console.log('ERROR - Tizen.getAppId: ', error);
      return '';
    }
  }

  static get getPackageId() {
    try {
      return window.tizen.application.getCurrentApplication().appInfo.packageId;
    } catch (error) {
      console.log('ERROR - Tizen.getPackageId: ', error);
      return '';
    }
  }

  // Die Version der installierten WGT - das `version`-Attribut aus der
  // config.xml des Packagings (_tizen/tizenstartapp). Die App hier wird von
  // dort nur geladen; ob ein Geraet die aktuelle WGT hat, sagt allein dieser
  // Wert. appInfo.version zuerst, das Package als Rueckfall.
  static get getWgtVersion() {
    try {
      const v = window.tizen.application.getCurrentApplication().appInfo.version;
      if (v) return String(v);
    } catch (error) {
      console.log('ERROR - Tizen.getWgtVersion (appInfo): ', error);
    }
    try {
      const pkg = window.tizen.package.getPackageInfo(Tizen.getPackageId || null);
      if (pkg && pkg.version) return String(pkg.version);
    } catch (error) {
      console.log('ERROR - Tizen.getWgtVersion (package): ', error);
    }
    return '';
  }

  // Liefert alle auf dem TV installierten Apps (Promise<Array>).
  static getInstalledApps() {
    return new Promise((resolve) => {
      try {
        window.tizen.application.getAppsInfo(
          (apps) => {
            const list = apps.map((a) => ({
              id: a.id,
              name: a.name,
              version: a.version,
              packageId: a.packageId,
            }));
            resolve(list);
          },
          (error) => {
            console.log('ERROR - Tizen.getInstalledApps: ', error);
            resolve([]);
          }
        );
      } catch (error) {
        console.log('ERROR - Tizen.getInstalledApps: ', error);
        resolve([]);
      }
    });
  }

  /*
  static set setSystemConfig(value) {
    try {
      webapis.productinfo.setSystemConfig(webapis.productinfo.ProductInfoConfigKey.CONFIG_KEY_DATA_SERVICE, value, onsuccess, onerror);
      return true;
    } catch (error) {
      console.log("ERRROR: Tizen setSystemConfig data = " + error.code);
      return false;
    }
  }

  static onsuccess(data)  {
    console.log("SUCCESS: Tizen setSystemConfig data = " + data);
  }
  static onerror(error)  {
    console.log("error code : " + error.code);
  }
  */

  static PowerState() {
    try {
      const PowerState = this.b2bPower.getPowerState();
      store.dispatch('notification/new', {
        title: 'Power State',
        message: PowerState,
      });
    } catch (e) {
      store.dispatch('notification/new', {
        title: e.name,
        message: e.message,
      });
      console.log(
        '[getPowerState] call syncFunction exception [' +
          e.code +
          '] name: ' +
          e.name +
          ' message: ' +
          e.message
      );
    }
  }
  static callbackSuccess(name, context) {
    console.log('CALLBACK_SUCCESS: ', name, ' with context: ', context);
  }
  static callbackError(name, context) {
    console.log('CALLBACK_ERROR: ', name, ' with context: ', context);
  }
  // Aus- und Einschalten ueber b2bapis nur, wenn b2bpower beides kann.
  //
  // Am AU800 (Tizen 6.0) fehlt b2bpower.setPowerOff: turnOff lief dort ueber
  // b2bcontrol.setPowerOff, und das anschliessende b2bpower.setPowerOn rief
  // keinen Callback und schaltete nichts ein - der Bildschirm blieb schwarz.
  // Bis 04/2026 fiel das nicht auf: die b2bapis-Pruefung lief einmalig beim
  // Modul-Laden, b2bapis war da oft noch nicht nachgeladen, und die App nahm
  // webapis.remotepower - ein Paar, das auf dem AU800 aus- UND einschaltet.
  static get useRemotePower() {
    const b2b = window.b2bapis;
    const rp = window.webapis && window.webapis.remotepower;
    if (!rp) return false;
    if (!b2b) return true;
    return !b2b.b2bpower || typeof b2b.b2bpower.setPowerOff !== 'function';
  }
  static turnOff() {
    const cbSuccess = () => this.callbackSuccess('turnOff');
    const cbError = () => this.callbackError('turnOff');
    //console.log('=================================================Turning off TV - hasWebapis', hasWebapis);
    //console.log('=================================================Turning off TV - hasB2bapis', hasB2bapis);
    if(this.useRemotePower) {
      console.log('=================================================Turning off TV - webapis.remotepower');
      window.webapis.remotepower.powerOff();
    } else if(window.b2bapis) {
      console.log('=================================================Turning off TV - b2bControl', this.b2bControl);
      this.b2bControl.setPowerOff(cbSuccess, cbError);
    } else if(window.webapis) {
      console.log('=================================================Turning off TV - webapis.remotepower');
      window.webapis.remotepower.powerOff();
    }
  }
  static turnOn() {
    const cbSuccess = () => this.callbackSuccess('turnOn');
    const cbError = (err) => this.callbackError('turnOn', err);
    if(this.useRemotePower) {
      console.log('=================================================Turning on TV - webapis.remotepower');
      window.webapis.remotepower.powerOn();
    } else if(window.b2bapis) {
      console.log('=================================================Turning on TV - b2bPower', this.b2bPower);
      this.b2bPower.setPowerOn(cbSuccess, cbError);
    } else if(window.webapis) {
      console.log('=================================================Turning on TV - webapis.remotepower');
      window.webapis.remotepower.powerOn();
    }
  }

  // Startet das Geraet neu. Liefert ein Promise mit { ok, via, detail } fuer
  // die Antwort an den SocketAdmin - bisher kam dort nichts an, und ob der
  // Befehl griff, liess sich nur raten.
  //
  // via nennt die API (b2bapis.b2bcontrol oder webapis.systemcontrol, siehe
  // b2bControl). Der Erfolgs-Callback kommt je nach Firmware noch vor dem
  // Neustart oder gar nicht mehr; ohne Callback nach REBOOT_REPLY_MS gilt der
  // Aufruf als angenommen. Ob wirklich neu gestartet wurde, zeigt danach
  // appStartedAt im Admin.
  //
  // Beide APIs nacheinander: am BU800 (Tizen 6.5) fehlte window.b2bapis, und
  // webapis.systemcontrol.rebootDevice antwortete mit SecurityError (Code 18) -
  // der Neustart fiel aus. Scheitert die erste, wird die zweite versucht; die
  // Antwort nennt alle Versuche.
  static reboot() {
    const b2b = window.b2bapis && window.b2bapis.b2bcontrol;
    const sc = window.webapis && window.webapis.systemcontrol;
    const candidates = [
      { via: 'b2bapis.b2bcontrol', api: b2b },
      { via: 'webapis.systemcontrol', api: sc },
    ].filter((c) => c.api && typeof c.api.rebootDevice === 'function');
    console.log(
      '[reboot] b2bapis ' + (window.b2bapis ? 'da' : 'FEHLT') + ', Kandidaten: ' +
        (candidates.map((c) => c.via).join(', ') || 'keine')
    );
    const tried = [];
    const attempt = (i) =>
      new Promise((resolve) => {
        if (i >= candidates.length) {
          resolve({
            ok: false,
            via: tried.map((t) => t.via).join(' -> '),
            detail: tried.length
              ? tried.map((t) => t.via + ': ' + t.detail).join('; ')
              : 'rebootDevice gibt es auf diesem Geraet nicht',
          });
          return;
        }
        const c = candidates[i];
        let done = false;
        const finish = (r) => {
          if (done) return;
          done = true;
          clearTimeout(timer);
          console.log('[reboot] ' + c.via + ': ' + JSON.stringify(r));
          if (r.ok) {
            resolve(Object.assign({ via: c.via }, r));
            return;
          }
          tried.push({ via: c.via, detail: r.detail });
          attempt(i + 1).then(resolve);
        };
        const timer = setTimeout(
          () => finish({ ok: true, detail: 'kein Callback - Neustart vermutlich ausgeloest' }),
          REBOOT_REPLY_MS
        );
        try {
          c.api.rebootDevice(
            () => finish({ ok: true, detail: 'rebootDevice angenommen' }),
            (err) => finish({ ok: false, detail: String((err && (err.message || err.name)) || err) })
          );
        } catch (e) {
          finish({ ok: false, detail: String((e && (e.message || e.name)) || e) });
        }
      });
    return attempt(0);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/Device/Tizen.js